import {
	FormControl,
	FormLabel,
	Input,
	FormErrorMessage,
} from "@chakra-ui/react";
import {
	Entity,
	EntityCreateViewModel,
	EntityUpdateViewModel,
} from "@common/entities/entity.model";
import {
	entityCreateSchema,
	entityUpdateSchema,
} from "@common/entities/entity.schema";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useResource } from "hooks/resources/providers/resourceProvider";
import { DataTableForm } from "components/elements/Datatable/data-table-form";
import LocationAutocomplete from "components/elements/LocationAutocomplete";

export function EntityForm() {
	const { modal, params } = useResource<Entity>();

	const entity = modal.selectedOne;

	const defaultValues = entity ? entity : { company: params?.company };

	const form = useForm<EntityCreateViewModel | EntityUpdateViewModel>({
		resolver: zodResolver(entity ? entityUpdateSchema : entityCreateSchema),
		defaultValues: defaultValues,
	});

	return (
		<DataTableForm<Entity, EntityCreateViewModel, EntityUpdateViewModel>
			resource="Entity"
			form={form}
		>
			<Input {...form.register("company")} type="hidden" />
			<FormControl isInvalid={!!form.formState.errors.name} isRequired>
				<FormLabel>Name</FormLabel>
				<Input
					variant="primary"
					type="text"
					{...form.register("name")}
					placeholder="Name"
				/>
				<FormErrorMessage>
					{form.formState.errors.name?.message}
				</FormErrorMessage>
			</FormControl>

			<FormControl
				isInvalid={!!form.formState.errors.established_date}
				isRequired
			>
				<FormLabel>Established Date</FormLabel>
				<Input
					variant="primary"
					type="date"
					{...form.register("established_date")}
					placeholder="Established Date"
				/>
				<FormErrorMessage>
					{form.formState.errors.established_date?.message}
				</FormErrorMessage>
			</FormControl>

			<FormControl isInvalid={!!form.formState.errors.address} isRequired>
				<FormLabel>Address</FormLabel>
				<LocationAutocomplete
					onChange={(val) => form.setValue("address", val.formatted)}
					defaultValue={form.getValues("address")}
					placeholder="Address"
				/>
				<FormErrorMessage>
					{form.formState.errors.address?.message}
				</FormErrorMessage>
			</FormControl>
		</DataTableForm>
	);
}
